<label class="checkbox-container">
  <input class="checkbox-input" type="checkbox" [ngModel]="checked" (ngModelChange)="onModelChange($event)" />
  <span class="checkbox-house" [inlineSVG]="'../../../assets/huisje.svg'" [ngClass]="{ checked: checked }"></span>
  <ng-content> </ng-content>
</label>
